import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from '@services/token.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private tokenService: TokenService) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (request.url.includes('/api/')) {
            // add authorization header with jwt token if available
            const token = this.tokenService.token;
            if (token) {
                request = request.clone({
                    headers: request.headers.set(
                        'Authorization',
                        `JWT ${token}`
                    ),
                });
            }
        }

        return next.handle(request).pipe(
            catchError(error => {
                return throwError(error);
            })
        );
    }
}
